import Api from "./Api";
import Csrf from "./Csrf";

export default {
	
	async index() {
		await Csrf.getCookie();
		
		return Api.get("/workplaces");
	},
	
	async store(form) {
		await Csrf.getCookie();
		
		return Api.post("/workplaces",form);
	},

	async update(id,form) {
		await Csrf.getCookie();
		
		return Api.put("/workplaces/"+id,form);
	},
	
	async delete(id) {
		await Csrf.getCookie();
		
		return Api.delete("/workplaces/"+id);
	},
	
};